import { Theme } from '@mui/material';
import { WbGrid, WbGridCol, WbGridRow, WbHeading, WbLink, WbText } from '@workbench/react';
import { makeStyles } from 'tss-react/mui';
import { FormattedMessage } from 'react-intl';
import { UrlsCollection } from '../../../utility/links';
import { useTranslation } from '../../../common/i18n/useTranslation';

const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        width: '100%',
        display: 'grid',
        gap: theme.spacing(2),
    },
    mercedesContact: {
        whiteSpace: 'pre-line',
    },
    chairmanContainer: {
        display: 'flex',
        gap: theme.spacing(0.5),
    },
}));

export default function ProviderTab() {
    const { classes } = useStyles();
    const translate = useTranslation();

    return (
        <WbGrid className={classes.container}>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <WbHeading size="s">Mercedes-Benz AG</WbHeading>
                </WbGridCol>
            </WbGridRow>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <WbHeading size="xs">{translate('Provider')}</WbHeading>
                    <WbText size="l" className={classes.mercedesContact}>
                        <FormattedMessage
                            id="ProviderTabMercedesAddress"
                            defaultMessage={'ProviderTabMercedesAddress'}
                            values={{ br: <br /> }}
                        />
                    </WbText>
                </WbGridCol>
            </WbGridRow>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <WbText size="l">{translate('ProviderTabCourtOfRegistry')}</WbText>
                </WbGridCol>
            </WbGridRow>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <WbText size="l">{translate('ProviderTabRepresentedTitle')}</WbText>
                    <WbText size="l">{translate('ProviderTabRepresentedContent')}</WbText>
                </WbGridCol>
            </WbGridRow>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <div className={classes.chairmanContainer}>
                        <WbText size="l">{translate('ProviderTabChairmanTitle')}</WbText>
                        <WbText size="l">{translate('ProviderTabChairmanContent')}</WbText>
                    </div>
                </WbGridCol>
            </WbGridRow>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <WbText size="l" className={classes.mercedesContact}>
                        <FormattedMessage
                            id="ProviderTabMercedesContactDetails"
                            defaultMessage={'ProviderTabMercedesContactDetails'}
                            values={{ br: <br /> }}
                        />
                        <WbLink variant="inline" href="mailto:dialog@mercedes-benz.com">
                            {UrlsCollection.Provider_MAIL_ADDRESS}
                        </WbLink>
                    </WbText>
                </WbGridCol>
            </WbGridRow>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <div className={classes.chairmanContainer}>
                        <WbText size="l">{translate('ProviderVATRegistrationNumberTitle')}</WbText>
                        <WbText size="l">{translate('ProviderTabVatId')}</WbText>
                    </div>
                </WbGridCol>
            </WbGridRow>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <WbHeading size="xs">{translate('LegalNoticeTabOnlineDisputeTitle')}</WbHeading>
                    <WbText size="l">
                        <FormattedMessage
                            id="LegalNoticeTabOnlineDisputeContent"
                            defaultMessage={'LegalNoticeTabOnlineDisputeContent'}
                            values={{ br: <br /> }}
                        />
                        <WbLink
                            variant="inline"
                            href={UrlsCollection.ONLINE_DISPUTE_LINK}
                            target="_blank"
                            rel="noreferrer"
                            className="wb-link wb-link--inline"
                        >
                            {UrlsCollection.ONLINE_DISPUTE_LINK}
                        </WbLink>
                    </WbText>
                </WbGridCol>
            </WbGridRow>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <WbHeading size="xs">{translate('LegalNoticeTabVsbgTitle')}</WbHeading>
                    <WbText size="l">
                        <FormattedMessage
                            id="LegalNoticeTabVsbgContent"
                            defaultMessage={'LegalNoticeTabVsbgContent'}
                            values={{ br: <br /> }}
                        />
                    </WbText>
                </WbGridCol>
            </WbGridRow>
        </WbGrid>
    );
}
